import { Component, Input, OnInit } from "@angular/core";
import { DataService_Student_Scan_History } from "../shared/data.service";

@Component({
	selector: "caass-student-scan-view-block-list",
	templateUrl: "./student-scan-view-block-list.component.html",
	styleUrls: ["./student-scan-view-block-list.component.css"],
})
export class StudentScanViewBlockListComponent implements OnInit {
	constructor(private ScanHistoryService: DataService_Student_Scan_History) {}

	ngOnInit(): void {
		this.loadStationBlockAlert();
	}

	ngOnChanges() {
		this.loadStationBlockAlert();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Input
	@Input() SelectedEntry: any;

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	SelectedStationBlockAlert: any;
	lstStationBlockAlert: any = [];

	//Filter lists
	lstPriorityDesc: any = [];

	cols: any = [
		{ field: "Message", header: "Message" },
		{ field: "PriorityDesc", header: "Priority" },
		{ field: "DateRangeDesc", header: "Date Range" },
		{ field: "TimeDesc", header: "Time Range" },
	];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadStationBlockAlert() {
		var result = this.ScanHistoryService.ScanBlockAlertSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				this.lstStationBlockAlert = response;

				//Load Data Filter Lists
				this.lstPriorityDesc = Array.from(new Set(this.lstStationBlockAlert.map((item: any) => item.PriorityDesc))).sort();
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadStationBlockAlert();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedStationBlockAlert = val.data;
	}
	onRowUnselect(val) {
		this.SelectedStationBlockAlert = null;
	}
	////////////////////////////////////////////
}
